import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "MQAModal__title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("b", null, "批量调整额度", -1)
const _hoisted_3 = {
  key: 0,
  class: "MQAModal__tabs"
}
const _hoisted_4 = { style: {"padding":"20px"} }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", null, "设置无限额度后所选车辆加油将直接扣减企业账户余额。", -1)
const _hoisted_6 = { style: {"text-align":"right"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_radio_button = _resolveComponent("a-radio-button")!
  const _component_available_quota = _resolveComponent("available-quota")!
  const _component_regular_quota = _resolveComponent("regular-quota")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visible) = $event)),
    width: "680px",
    "dialog-class": "MQAModal",
    footer: null,
    onCancel: _ctx.onCancel
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(" - " + _toDisplayString(_ctx.actionProps.addtional), 1)
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.actionProps.activeObject === 'vehicle')
        ? (_openBlock(), _createBlock(_component_a_radio_group, {
            key: 0,
            value: _ctx.quotaFlag,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.quotaFlag) = $event)),
            class: "quotaType"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio, {
                value: 0,
                style: {"padding-right":"50px"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode("设置额度")
                ]),
                _: 1
              }),
              _createVNode(_component_a_radio, { value: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode("无限额度")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]))
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", null, [
        (!_ctx.isScheduleModel)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_a_radio_group, {
                value: _ctx.activeTab,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.activeTab) = $event)),
                size: "large",
                "button-style": "solid"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_radio_button, { value: "available" }, {
                    default: _withCtx(() => [
                      _createTextVNode("可用额度")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_radio_button, { value: "regular" }, {
                    default: _withCtx(() => [
                      _createTextVNode("定期额度")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_available_quota, {
          ref: "AvailableQuotaRef",
          "action-props": _ctx.actionProps,
          onCancel: _ctx.onCancel,
          onComplete: _ctx.onComplete
        }, null, 8, ["action-props", "onCancel", "onComplete"]), [
          [_vShow, _ctx.activeTab === 'available']
        ]),
        _withDirectives(_createVNode(_component_regular_quota, {
          ref: "RegularQuotaRef",
          "action-props": _ctx.actionProps,
          onCancel: _ctx.onCancel,
          onComplete: _ctx.onComplete
        }, null, 8, ["action-props", "onCancel", "onComplete"]), [
          [_vShow, _ctx.activeTab === 'regular']
        ])
      ], 512), [
        [_vShow, _ctx.quotaFlag === 0]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_a_button, {
            style: {"margin-right":"14px"},
            onClick: _ctx.onCancel
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_a_button, {
            type: "primary",
            onClick: _ctx.onSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ], 512), [
        [_vShow, _ctx.quotaFlag === 1]
      ])
    ]),
    _: 1
  }, 8, ["visible", "onCancel"]))
}